import request from '@/utils/request'

// 年份下拉框数据
export function selectMap (param) {
  return request({
    url: '/project/install/province',
    method: 'get',
    params: param
  })
}
